module.exports = __webpack_public_path__ + "static/media/frontend.7a26777b.png";